import React, { useEffect } from 'react';
import { useOLMap } from '../MapContext';
import { actionSetLayerFeatureHighlight } from '../../actions';
import { featureToGeoJSONObject } from '../../utils/featureToGeoJSONObject';
export const InteractionHighlight = React.memo(({ dispatch, layerFilter, geometryTypeFilter, highlightedFeaturesCount }) => {
    const map = useOLMap();
    useEffect(() => {
        if (!dispatch)
            return;
        let lastLayerIds = null;
        const handlePointerMove = (event) => {
            if (event.dragging) {
                return;
            }
            requestAnimationFrame(() => {
                const highlightedFeatures = [];
                map.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
                    const layerId = feature.get('layer_id') ?? layer?.get('id');
                    const featureId = (feature.getId() || feature.get('id'));
                    let isFiltered = true;
                    if (geometryTypeFilter) {
                        const geomType = feature.getGeometry()?.getType();
                        isFiltered = !!geomType && geometryTypeFilter.includes(geomType);
                    }
                    if (layerId && featureId && isFiltered) {
                        highlightedFeatures.push({
                            featureId,
                            layerId,
                            feature: featureToGeoJSONObject(feature),
                        });
                    }
                }, {
                    layerFilter,
                });
                if (highlightedFeatures.length > 0) {
                    dispatch(actionSetLayerFeatureHighlight({
                        highlightedFeatures: highlightedFeatures.slice(0, highlightedFeaturesCount),
                        coordinate: event.coordinate,
                    }));
                    lastLayerIds = highlightedFeatures.map((highlightedFeature) => highlightedFeature.layerId);
                }
                else if (lastLayerIds) {
                    dispatch(actionSetLayerFeatureHighlight({
                        highlightedFeatures: [],
                        coordinate: event.coordinate,
                    }));
                }
            });
        };
        map.on('pointermove', handlePointerMove);
        return () => {
            map.un('pointermove', handlePointerMove);
        };
    }, [map, layerFilter, dispatch, highlightedFeaturesCount, geometryTypeFilter]);
    return null;
});
//# sourceMappingURL=InteractionHighlight.js.map